import React, { useEffect } from 'react';
import { FaTimes, FaDownload } from 'react-icons/fa';
import { getAttachmentIcon, formatFileSize } from './attachmentKind';
import './TalkAttachmentModals.css';

const TalkAttachmentUnsupportedModal = ({ upload, onClose }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    if (!upload) return null;

    const Icon = getAttachmentIcon(upload.name);
    const handleBackdropClick = (e) => { if (e.target === e.currentTarget) onClose(); };

    return (
        <div
            className="talk-attach-overlay"
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-label={`${upload.name} cannot be previewed`}
        >
            <div className="talk-attach-modal talk-attach-modal--compact">
                <div className="talk-attach-header">
                    <span className="talk-attach-title" title={upload.name}>{upload.name}</span>
                    <button className="talk-attach-close-btn" onClick={onClose} aria-label="Close">
                        <FaTimes />
                    </button>
                </div>
                <div className="talk-attach-body talk-attach-body--static">
                    <div className="talk-attach-state-overlay talk-attach-body--static">
                        <Icon className="talk-attach-unsupported-icon" />
                        <div className="talk-attach-unsupported-name">{upload.name}</div>
                        {typeof upload.size === 'number' && (
                            <div className="talk-attach-unsupported-size">{formatFileSize(upload.size)}</div>
                        )}
                        <p>This file type can't be previewed here.</p>
                        <a
                            className="talk-attach-download-btn"
                            href={upload.url}
                            download={upload.name}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaDownload /> Download
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TalkAttachmentUnsupportedModal;
